module.exports = __webpack_public_path__ + "img/bespoke123_16.d1dcd0ab.jpg";